import { ChangeEvent } from 'react';
import { Input, Box } from '@nimbus-ds/components';
import { ErrorMessage } from './ErrorMessage';
import { FormField } from './FormField';

interface FormInputProps {
  label: string;
  name: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  error?: string;
  isLoading?: boolean;
  type?: 'text' | 'email' | 'tel' | 'number';
  placeholder?: string;
}

export function FormInput({
  label,
  name,
  value,
  onChange,
  onBlur,
  error,
  isLoading = false,
  type = 'text',
  placeholder,
}: Readonly<FormInputProps>) {
  return (
    <FormField label={label}>
      {isLoading ? (
        <Box width="100%">
          <Input.Skeleton />
        </Box>
      ) : (
        <>
          <Input
            name={name}
            type={type}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            appearance={error ? 'danger' : 'neutral'}
            placeholder={placeholder}
          />
          <ErrorMessage error={error} />
        </>
      )}
    </FormField>
  );
}
